@use "~theme/breakpoints";
@use "~theme/typography";

.address {
  font-style: normal;
}

.mobileOnly {
  @include breakpoints.desktop {
    display: none;
  }
}

.desktopOnly {
  display: none;

  @include breakpoints.desktop {
    display: inline;
  }
}

.mileTextBox {
  @include typography.caption;
  background: var(--blue-03);
  padding: 5px 10px;
  border-radius: 5px;
  color: var(--blue-01);
  margin: 12px 0 8px;
  display: inline-block;
}

.footerPhoneLink {
  white-space: nowrap;
}